var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaubel07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.8,29.139v-9.613h-3.249v-0.975C58.551,13.836,54.715,10,50,10s-8.552,3.836-8.552,8.551v0.975H38.2v9.613 c-6.254,2.508-11.372,6.873-14.841,12.326h53.283C73.172,36.012,68.054,31.647,61.8,29.139z M54.551,19.526h-9.103v-0.975 c0-2.509,2.042-4.551,4.552-4.551c2.51,0,4.551,2.042,4.551,4.551V19.526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,90c10.955,0,20.622-5.609,26.287-14.104H23.713C29.378,84.391,39.045,90,50,90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.339,44.465H21.661c-2.083,4.239-3.238,8.986-3.238,13.963c0,5.213,1.278,10.131,3.525,14.469h56.103 c2.247-4.338,3.525-9.256,3.525-14.469C81.577,53.451,80.422,48.704,78.339,44.465z M31.677,65.696 c-3.461,0-6.266-3.141-6.266-7.015c0-3.874,2.805-7.015,6.266-7.015s6.266,3.141,6.266,7.015 C37.944,62.555,35.138,65.696,31.677,65.696z M50.136,65.696c-3.461,0-6.266-3.141-6.266-7.015c0-3.874,2.806-7.015,6.266-7.015 c3.461,0,6.266,3.141,6.266,7.015C56.402,62.555,53.597,65.696,50.136,65.696z M68.595,65.696c-3.461,0-6.266-3.141-6.266-7.015 c0-3.874,2.805-7.015,6.266-7.015c3.461,0,6.266,3.141,6.266,7.015C74.861,62.555,72.056,65.696,68.595,65.696z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaubel07);
export default __webpack_public_path__ + "static/media/baubel-07.d0314852df50747ea298dc2ca13276ad.svg";
export { ForwardRef as ReactComponent };